import { IWasteTreatment, PROCESS_DROPDOWN_OPTIONS } from '../../../../../../../PcfWizard.type';

export const filterWasteTreatments = (
  wasteTreatments?: IWasteTreatment[],
  processId?: PROCESS_DROPDOWN_OPTIONS,
): IWasteTreatment[] => {
  if (wasteTreatments?.length) {
    let _filteredWasteTreatments = wasteTreatments;

    // Filter by the process_id field.
    if (processId) {
      _filteredWasteTreatments = _filteredWasteTreatments.filter((item) => {
        return item.allowedProcesses?.includes(processId);
      });
    }

    return _filteredWasteTreatments;
  }

  return [];
};
